<template>
    <section class="dispatchOrder-table" v-loading="loading">
        <div class="dispatch-table-header">
            <el-button
                type="text"
                class="dispatch-refresh"
                :disabled="!selected.length && isCarDispatch"
                @click="handleRetweet"
            >
                重推
            </el-button>
            <div>
                <el-button
                    type="text"
                    class="dispatch-refresh"
                    @click="handleUpload"
                    v-has="'dispatch_transport_protocol_upload'"
                >
                    上传附件
                </el-button>
                <el-button
                    type="text"
                    class="dispatch-refresh"
                    icon="el-icon-refresh"
                    @click="handleRefresh"
                >
                    刷新
                </el-button>
            </div>
        </div>
        <table-box
            ref="tablePage"
            :selection="true"
            :columns="config.table.columns"
            :height="config.table.height"
            :rows="tableData"
            :actions="config.table.action"
            @action-click="actionClick"
            @selection-change="handleSelectionChange"
        >
        </table-box>
        <m-page
            :current-page="currentPage"
            :pageData="config.page"
            :total="pageTotal"
            @on-page-change="pageChange"
            @on-size-change="sizeChange"
            class="page-container"
        ></m-page>
        <PerformancePreviewFile
            :attachmentList="attachmentList"
            ref="performancePreviewFile"
        ></PerformancePreviewFile>
        <!-- 上传附件 -->
        <dispatch-attachment-upload
            ref="imageManageUpload"
            v-if="fileUploadVisible"
            :visible.sync="fileUploadVisible"
            @update:attachmentUploadVisible="fileUploadVisible = false"
            @submit="fileUploadVisible = false"
            @uploadSuccess="uploadSuccess"
        ></dispatch-attachment-upload>
        <!-- 上传附件 -->
    </section>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api.js';
import { confirmWithBtnLoading } from '@/modules/transport/otp/views/distributeManage/dispatchMgmt/components/util/index';
import tableBox from '@/components/lots/tableBox/Index.vue';
import mPage from '@/components/otpPanel/mPage';
import PerformancePreviewFile from '@/modules/transport/otp/components/PerformancePreviewFile';
import dispatchAttachmentUpload from '../../components/dispatchAttachmentUpload/Index';
import config from './config.js';
import { attachmentPage, uploadTransportProtocol, uploadRetryTransportProtocol } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import { formatTotalDataList, downloadFile } from './util';

export default {
    name: 'dispatchPrintTransportProtocolTable',
    components: { tableBox, mPage, PerformancePreviewFile, dispatchAttachmentUpload },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            fileUploadVisible: false,
            selected: [], // 选中数据
            tableData: [], // 列表数据
            page: {
                pageSize: 10,
                pageNo: 1
            },
            dictDataCode: [
                'THORN_ATTACHMENT_STATUS_TYPE', // 签章状态
                'TP_DOCUMENTS_WAY', // 生成方式
                'OTP_ATTACHMENT_TYPE' // 履约附件类型
            ],
            dictData: {}, // 数据字典集合
            pageTotal: 0,
            currentPage: 1,
            attachmentList: []

        };
    },
    computed: {
        /**
         * @description dispatchStatus： 待确认(0), 待到车(10), 待装车(20), 待发车(30), 在途(40), 待签收(60), 抵达(50), 完成(100)
         * @description 未发车之前才展示该按钮条件判断
         * @description 发车前状态: 待确认(0), 待到车(10), 待装车(20), 待发车(30)
         */
        isCarDispatch () {
            return [0, 10, 20, 30].includes(+this.componentsData.dispatchStatus);
        }
    },
    mounted () {
        this.getList();
    },
    methods: {
        /**
         * @getList 获取列表接口
         * @param {Object} searchParams 查询条件
         */
        async getList () {
            const dict = await dictWithUrl(this.dictDataCode.join(','));
            this.dictData = dict.data;
            this.loading = true;
            attachmentPage({
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                param: {
                    objId: this.componentsData.id,
                    objType: 'TRANSPORT_AGREEMENT_FILE'
                }
            }).then((res) => {
                if (res && +res.code === 0) {
                    res.data.list.forEach(e => {
                        e.dispatchStatus = this.componentsData.dispatchStatus;
                    });
                    this.tableData = formatTotalDataList(res.data.list, this.dictData);
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        /**
         * @description 重推
         *
        */
        handleRetweet () {
            const msg = '确定要重推嗎?';
            const params = this.selected.map(item => { return item.objId; });
            const errMsg = '操作成功';
            confirmWithBtnLoading(msg, params, uploadRetryTransportProtocol, errMsg).then((res) => {
                this.getList();
            }).catch(() => { });
        },
        /**
         * @description 上传附件弹窗
        */
        handleUpload () {
            this.fileUploadVisible = true;
        },
        /**
         * @description 上传附件弹窗回调
        */
        uploadSuccess (data) {
            const param = {
                objType: 'TRANSPORT_AGREEMENT_FILE',
                objId: this.componentsData.id,
                fileSize: data.fileSize,
                name: data.fileName,
                path: data.downUrl,
                dispatchNo: this.componentsData.dispatchNo
            };
            uploadTransportProtocol(param).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('上传成功');
                    this.getList();
                    this.fileUploadVisible = false;
                }
            });
        },
        /**
         * @description 刷新
        */
        handleRefresh () {
            this.page = {
                pageSize: 10,
                pageNo: 1
            };
            this.getList();
        },
        /**
         * @description 操作列事件处理
         * @event {事件类型} viewImg 查看影像、 downloadFile 下载附件 retweet 重推
         * @row   {Object} 行数据
        */
        actionClick (event, row, rIndex) {
            /* eslint-disable indent */
            switch (event) {
                case 'viewImg':
                    this.attachmentList = [row];
                    this.$nextTick(() => {
                        this.$refs.performancePreviewFile.show();
                    });
                    break;
                case 'downloadFile':
                    downloadFile(row, row.path);
                    break;
                case 'retweet':
                    this.handleRetweet(row);
                    break;
                default:
                    break;
            }
        },
        /**
         * @description 复选框勾选
         * @param {Array} rows 勾选的数据
        */
        handleSelectionChange (rows) {
            this.selected = rows;
        },
        // 页数改变
        sizeChange (data) {
            this.page.pageSize = data;
            this.getList();
        },
        // 切分页
        pageChange (data) {
            this.page.pageNo = data;
            this.getList();
        }
    }
};
</script>

<style  lang="less" scoped>
.dispatchOrder-table {
    margin-bottom: 40px;
    .dispatch-table-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .table-pagination {
        margin-top: 10px;
    }
    .mPane3-back-up .el-table {
        min-height: inherit;
    }
}
.dispatchOrder-table .model-table-search {
    display: none;
}
</style>
